import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { Toast } from "primereact/toast";
import {
  OilIntakeLogModel,
  VendorResponse,
} from "../../models/oilProduction-model";
import oilProductionService from "../../services/oilProduction/oilProductionservice";
import { BreadCrumb } from "primereact/breadcrumb";
import { useNavigate } from "react-router-dom";

interface Option {
  label: string;
  value: number;
}
interface DropdownOption {
  label: string;
  value: number;
}

interface OilseedOption {
  label: string;
  value: number;
}

interface VendorOption {
  label: string;
  value: number;
}

interface InvoiceOption {
  label: string;
  value: number;
  quantityLeft: number;
}

interface Props {
  data?: OilIntakeLogModel[];
  setLoading: (loading: boolean) => void;
}
interface InvoiceOption {
  label: string;
  value: number;
  quantityLeft: number;
}

const OilProductionDataTable2: React.FC<Props> = ({ data, setLoading }) => {
  const [records, setRecords] = useState<OilIntakeLogModel[]>([]);

  const [showDialog, setShowDialog] = useState(false);
  const [startTime, setStartTime] = useState<Date>(new Date());
  const [endTime, setEndTime] = useState<Date>(new Date());
  // const [selectedOperator1, setSelectedOperator1] = useState<Option | null>(
  //   null
  // );
  // const [selectedOperator2, setSelectedOperator2] = useState<Option | null>(
  //   null
  // );
  // const [selectedBull1, setSelectedBull1] = useState<Option | null>(null);
  // const [selectedBull2, setSelectedBull2] = useState<Option | null>(null);

  const [selectedOperator1, setSelectedOperator1] = useState<number | null>(
    null
  );
  const [selectedOperator2, setSelectedOperator2] = useState<number | null>(
    null
  );
  const [selectedBull1, setSelectedBull1] = useState<number | null>(null);
  const [selectedBull2, setSelectedBull2] = useState<number | null>(null);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<OilIntakeLogModel | null>(
    null
  );
  const [gaanaNumber, setGaanaNumber] = useState<number | null>(null);
  const [gaanaOptions, setGaanaOptions] = useState<Option[]>([]);
  const [oilseedWeight, setOilseedWeight] = useState<number | null>(null);
  const [moistureContent, setMoistureContent] = useState<number | null>(null);
  const [emptyContainerWeight, setEmptyContainerWeight] = useState<
    number | null
  >(null);
  const [vendors, setVendors] = useState<DropdownOption[]>([]);
  const [vendorInvoices, setVendorInvoices] = useState<VendorResponse[]>([]);
  const [operators, setOperators] = useState<Option[]>([]);
  const [bulls, setBulls] = useState<Option[]>([]);
  const toast = useRef<Toast>(null);
  const [manufactureId, setManufactureId] = useState<number | null>(null);

  const [oilseedOptions, setOilseedOptions] = useState<
    { label: string; value: number }[]
  >([]);

  const [oilseed, setOilseed] = useState<{ label: string; value: any } | null>(
    null
  );

  const [oilseeds, setOilseeds] = useState<OilseedOption[]>([]);
  const [vendorOptions, setVendorOptions] = useState<VendorOption[]>([]);
  const [selectedVendor, setSelectedVendor] = useState<number | null>(null);

  const [invoiceOptions, setInvoiceOptions] = useState<InvoiceOption[]>([]);
  const [selectedInvoice, setSelectedInvoice] = useState<InvoiceOption | null>(
    null
  );

  const isEditMode = !!selectedRow;
  const [hoveredField, setHoveredField] = useState<string | null>(null);
  const [cakeWeight, setCakeWeight] = useState<number | null>(null);
  const [residueContainerWeight, setResidueContainerWeight] = useState<
    number | null
  >(null);
  const [residueWeight, setResidueWeight] = useState<number | null>(null);
  const [containerAndMaddiWeight, setContainerAndMaddiWeight] = useState<
    number | null
  >(null);
  const [maddiWeight, setMaddiWeight] = useState<number | null>(null);
  const [totalWeight, setTotalWeight] = useState<number | null>(null);
  const [containerMaddiWeight, setContainerMaddiWeight] = useState<
    number | null
  >(null);
  const [dailyOutputLitres, setDailyOutputLitres] = useState<number | null>(
    null
  );
  const [inputToOutputRatio, setInputToOutputRatio] = useState<number | null>(
    null
  );
  const navigate = useNavigate();

  const [showConfirmEndTimeDialog, setShowConfirmEndTimeDialog] = useState(false);
const [proposedEndTime, setProposedEndTime] = useState<Date>(new Date());




  useEffect(() => {
  if (data) {
    // If data is explicitly provided (even if empty), show it
    setRecords(data);
  } else {
    // If data is undefined (not passed), fetch from API
    fetchAllLogs();
  }
}, [data]);



const fetchAllLogs = async () => {
  setLoading(true);
  try {
    const response = await oilProductionService.getAllOilIntakeLogs1();
    const sorted = response.sort((a: any, b: any) => b.id - a.id);
    setRecords(sorted);
  } catch (error) {
    console.error("Failed to fetch logs", error);
  } finally {
    setLoading(false);
  }
};


  const handleStartClick = async (row: OilIntakeLogModel) => {
    debugger
    setSelectedRow(row);
    setShowDialog(true);
    setOilseedWeight(row.oilSeedWeight ?? null);
    setEmptyContainerWeight(row.emptyContainerWeightKG ?? null);
    if (row.posID) {
      try {
        const plantResponse = await oilProductionService.GetMUPlantNameById(
          row.posID
        );
        if (plantResponse) setManufactureId(plantResponse.posID);

        const membersResponse = await oilProductionService.getBullsAndOperators(
          row.posID
        );
        if (membersResponse) {
          setOperators(
            membersResponse.operators.map((op: any) => ({
              label: op.name,
              value: op.id,
            }))
          );
          setBulls(
            membersResponse.bulls.map((b: any) => ({
              label: b.name,
              value: b.id,
            }))
          );
          setGaanaOptions(
            (membersResponse.gaanaDetails || []).map((g: any) => ({
              label: g.gaanaNumber,
              value: g.id,
            }))
          );
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const validateStartForm = () => {
    // if (!startTime) { toast.current?.show({ severity: "warn", summary: "Validation", detail: "Start time required" }); return false; }
    // if (!selectedOperator1) { toast.current?.show({ severity: "warn", summary: "Validation", detail: "Select Operator 1" }); return false; }
    // if (!selectedBull1) { toast.current?.show({ severity: "warn", summary: "Validation", detail: "Select Bull 1" }); return false; }
    return true;
  };


    const validateStartForm1 = (): boolean => {
    
    if (!startTime || !endTime) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Start and end time are required",
        life: 3000,
      });
      return false;
    }
    
   
    if (!cakeWeight) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please Enter Cake Weight",
        life: 3000,
      });
      return false;
    }

     if (!residueContainerWeight) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please Enter Residue Container Weight",
        life: 3000,
      });
      return false;
    }
    if (!totalWeight) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please Enter Total Weight (Container + Oil) (Kg)",
        life: 3000,
      });
      return false;
    }
    if (!containerMaddiWeight) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please Enter Container and Bottom Maddi Weight (Kg)",
        life: 3000,
      });
      return false;
    }
    if (!containerMaddiWeight) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please Enter Maddi Weight with Container Weight",
        life: 3000,
      });
      return false;
    }
   
    return true;
  };

  //   if (!selectedRow ) return;

  //   const intakeLog = {
  //     endTime: endTime?.toTimeString().split(" ")[0] ?? null,
  //   };

  //   const processingOutput = {
  //     totalOilWeightWithContainerKG: totalWeight ?? 0,
  //     containerAndBottomMaddiWeight: containerAndMaddiWeight ?? 0,
  //     maddiWeightWithContainer: containerMaddiWeight ?? 0,
  //     maddiWeight: maddiWeight ?? 0,
  //     byProductID: 1,
  //     dailyOutputLitres: dailyOutputLitres ?? 0,
  //     inputToOutputRatio: inputToOutputRatio ?? " ",
  //     capacityLossReason: "",
  //   };

  //   const cakeOutput = {
  //     cakeWeightKG: cakeWeight ?? 0,
  //     residueContainerWeightKG: residueContainerWeight ?? 0,
  //     residueWeightKG: residueWeight ?? 0,
  //     byProductID: 1,
  //   };

  //   const payload = {
  //     intakeLog,
  //     processingOutput,
  //     cakeOutput,
  //     intakeLogId: selectedRow.id,
  //   };

  //   try {
  //     await oilProductionService.AddOilProcessingOutputOnly(payload);
  //     toast.current?.show({
  //       severity: "success",
  //       summary: "Success",
  //       detail: "Oil Intake Log saved successfully",
  //       life: 3000,
  //     });
  //     navigate("/oildatatable");
  //     setEndTime(new Date());
  //     setDailyOutputLitres(null);
  //     setInputToOutputRatio(null);
  //     setCakeWeight(null);
  //     setResidueContainerWeight(null);
  //     setResidueWeight(null);
  //     setSelectedRow(null);
  //     setTotalWeight(null);
  //     setContainerMaddiWeight(null);
  //     setContainerMaddiWeight(null);
  //     setContainerAndMaddiWeight(null);
  //     setShowDialog(false);
  //     fetchAllLogs();
  //   } catch (error) {
  //     toast.current?.show({
  //       severity: "error",
  //       summary: "Error",
  //       detail: "Failed to save oil intake log",
  //       life: 5000,
  //     });
  //   }
  // };
const handleStartSave = async () => {
   if (!selectedRow || !validateStartForm1()) return;
   console.log(cakeWeight)

  setProposedEndTime(new Date());
  setShowConfirmEndTimeDialog(true);
};

const confirmSaveWithEndTime = async () => {
  
  if (!selectedRow) return;
    //  if (!selectedRow || !validateStartForm1()) return;

  const intakeLog = {
    endTime: endTime?.toTimeString().split(" ")[0],
  };

  const processingOutput = {
    totalOilWeightWithContainerKG: totalWeight ?? 0,
    containerAndBottomMaddiWeight: containerAndMaddiWeight ?? 0,
    maddiWeightWithContainer: containerMaddiWeight ?? 0,
    maddiWeight: maddiWeight ?? 0,
    byProductID: 1,
    dailyOutputLitres: dailyOutputLitres ?? 0,
    inputToOutputRatio: inputToOutputRatio ?? " ",
    capacityLossReason: "",
  };

  const cakeOutput = {
    cakeWeightKG: cakeWeight ?? 0,
    residueContainerWeightKG: residueContainerWeight ?? 0,
    residueWeightKG: residueWeight ?? 0,
    byProductID: 1,
  };

  const payload = {
    intakeLog,
    processingOutput,
    cakeOutput,
    intakeLogId: selectedRow.id,
  };

  try {
    debugger
    await oilProductionService.AddOilProcessingOutputOnly(payload);
    toast.current?.show({
      severity: "success",
      summary: "Success",
      detail: "Oil Intake Log saved successfully",
      life: 3000,
    });

    resetForm();
    fetchAllLogs();
  } catch (error) {
    toast.current?.show({
      severity: "error",
      summary: "Error",
      detail: "Failed to save oil intake log",
      life: 5000,
    });
  }
};

  useEffect(() => {
    debugger
    if (manufactureId === null) return;
    (async () => {
      try {
        const response = await oilProductionService.getOilSeedNames(
          manufactureId
        );
        console.log("Oilseed Response:", response);
        const formatted = response.map((item: any) => ({
          label: `${item.rawMaterialName} (${item.availableQty} kg)`,
          value: item.rawMaterialID,
        }));
        console.log("Formatted Oilseed Options:", formatted);
        setOilseedOptions(formatted);
      } catch (err) {
        console.error(err);
      }
    })();
  }, [manufactureId]);

  useEffect(() => {
    const prefillData = async () => {
      if (!selectedRow) return;

      try {
        const { oilSeedID, invoiceID } = selectedRow;

        // 1. Prefill Oilseed (handle null safely)
        if (oilSeedID !== null) {
          setOilseed(oilSeedID);
          debugger
          const vendorResponse = await oilProductionService.getVendorsByOilseed(
            oilSeedID,
             selectedRow.posID 
          );

          setVendorInvoices(vendorResponse);
          const formattedVendors = vendorResponse.map((vendor: any) => ({
            label: vendor.firmInfo,
            value: vendor.vendorID,
          }));
          setVendors(formattedVendors);

          // 3. Prefill Vendor
          setSelectedVendor(selectedRow.vendorID);

          // 4. Load Invoices for selected Vendor
          const vendor = vendorResponse.find(
            (v:any) => v.vendorID === selectedRow.vendorID
          );
          if (vendor && vendor.invoices) {
            const formattedInvoices = vendor.invoices.map((inv: any) => ({
              label: `${inv.invoiceID} - ${inv.quantityLeft} kg`,
              value: inv.id,
              quantityLeft: inv.quantityLeft,
            }));
            setInvoiceOptions(formattedInvoices);

            // 5. Prefill Invoice
            const invoiceMatch = formattedInvoices.find(
              (inv) => inv.value === selectedRow.invoiceID
            );
            setSelectedInvoice(invoiceMatch || null);
          }
        }
      } catch (error) {
        console.error("Error during prefill:", error);
      }
    };

    if (isEditMode) prefillData();
  }, [selectedRow, isEditMode]);

  const handleEditClick = async (row: OilIntakeLogModel) => {
    setSelectedRow(row);
    setShowEditDialog(true);
    setGaanaNumber(row.gaanaID ?? null);

    try {
      // 1️⃣ Fetch Operators, Bulls, Gaana
      const membersResponse = await oilProductionService.getBullsAndOperators(
        row.posID
      );

      if (membersResponse) {
        // Prefill Gaana Options
        const gaanaList: Option[] = (membersResponse.gaanaDetails || []).map(
          (g: any) => ({
            label: String(g.gaanaNumber),
            value: g.id,
          })
        );
        setGaanaOptions(gaanaList);

        // Prefill Operators
        const operatorList: Option[] = (membersResponse.operators || []).map(
          (op: any) => ({
            label: op.name,
            value: op.id,
          })
        );
        setOperators(operatorList);

        // Set selected operators
        setSelectedOperator1(
          operatorList.find((op) => op.value === row.operator1ID)?.value || null
        );
        setSelectedOperator2(
          operatorList.find((op) => op.value === row.operator2ID)?.value || null
        );

        // Prefill Bulls
        const bullList: Option[] = (membersResponse.bulls || []).map(
          (b: any) => ({
            label: b.name,
            value: b.id,
          })
        );
        setBulls(bullList);

        // Set selected bulls
        setSelectedBull1(
          bullList.find((b) => b.value === row.bull1ID)?.value || null
        );
        setSelectedBull2(
          bullList.find((b) => b.value === row.bull2ID)?.value || null
        );
      }

      // 2️⃣ Fetch Oilseed options
      const oilseedResponse = await oilProductionService.getOilSeedNames(
        row.posID
      );
      const oilseedList: OilseedOption[] = (oilseedResponse || []).map(
        (o: any) => ({
          label: `${o.rawMaterialName || o.oilSeedName || "Unknown"} (${
            o.availableQty || 0
          } kg)`,
          value: o.rawMaterialID || o.oilSeedID || 0,
        })
      );
      setOilseedOptions(oilseedList);

      // Prefill selected oilseed
      setOilseed(oilseedList.find((o) => o.value === row.oilSeedID) || null);

      // 3️⃣ Fetch Vendors and Invoices (already implemented)
      if (row.oilSeedID) {
        const vendorsResponse: VendorResponse[] =
          await oilProductionService.getVendorsByOilseed(
            row.oilSeedID,
            row.posID
          );
        setVendorInvoices(vendorsResponse);

        const formattedVendors: VendorOption[] = vendorsResponse.map((v) => ({
          label: v.firmInfo,
          value: v.vendorID,
        }));
        setVendorOptions(formattedVendors);

        // Prefill selected vendor
        const vendorMatch = formattedVendors.find(
          (v) => v.value === row.vendorID
        );
        setSelectedVendor(vendorMatch?.value || null);

        // Prefill invoices
        const vendorObj = vendorsResponse.find(
          (v) => v.vendorID === row.vendorID
        );
        if (vendorObj?.invoices) {
          const formattedInvoices: InvoiceOption[] = vendorObj.invoices.map(
            (inv) => ({
              label: `${inv.invoiceID} - ${inv.quantityLeft} kg`,
              value: Number(inv.invoiceID),
              quantityLeft: inv.quantityLeft,
            })
          );
          setInvoiceOptions(formattedInvoices);

          const invoiceMatch = formattedInvoices.find(
            (inv) => inv.value === Number(row.invoiceNumber)
          );
          setSelectedInvoice(invoiceMatch || null);
        }
      }

      // 5️⃣ Prefill remaining fields
      setOilseedWeight(row.oilSeedWeight ?? null);
      setMoistureContent(row.moistureContent ?? null);
      setEmptyContainerWeight(row.emptyContainerWeightKG ?? null);
    } catch (error) {
      console.error("Error in handleEditClick:", error);
    }
  };

  const handleEditSave = async () => {
     if (!selectedRow || !validateStartForm()) return;
    const payload = {
       id: selectedRow.id,
        operator1ID: selectedOperator1 ?? null,
      operator2ID: selectedOperator2 ?? null,
      bull1ID: selectedBull1 ?? null,
      bull2ID: selectedBull2 ?? null,
    };

    try {
      await oilProductionService.updateOilIntakeLog2(selectedRow.id, payload);
      toast.current?.show({
        severity: "success",
        summary: "Success",
        detail: "Record updated successfully",
      });
      setShowEditDialog(false);
      fetchAllLogs();
    } catch (err) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to update record",
      });
    }
  };

  const actionTemplateStart = (row: OilIntakeLogModel) => (
    <Button
      label="Stop"
      className="p-button-success"
      onClick={() => handleStartClick(row)}
    />
  );

  const actionTemplateEdit = (row: OilIntakeLogModel) => (
    <Button
      label="Edit"
      className="p-button-warning"
      onClick={() => handleEditClick(row)}
    />
  );
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const calculateElapsedTime = (
    startTimeStr: string,
    createdDateStr: string
  ) => {
    if (!startTimeStr) return "--:--:--";

    const now = currentTime;

    const [hoursStr, minutesStr, secondsStr] = startTimeStr.split(":");
    const hours = Number(hoursStr);
    const minutes = Number(minutesStr);
    const seconds = Number(secondsStr);

    const startDate = new Date(createdDateStr);
    startDate.setHours(hours, minutes, seconds, 0);

    if (startDate.getTime() > now.getTime()) {
      startDate.setDate(startDate.getDate() - 1);
    }

    let diffInSeconds = Math.floor(
      (now.getTime() - startDate.getTime()) / 1000
    );
    if (diffInSeconds < 0) return "00:00:00";

    const totalHours = Math.floor(diffInSeconds / 3600);
    const m = String(Math.floor((diffInSeconds % 3600) / 60)).padStart(2, "0");
    const s = String(diffInSeconds % 60).padStart(2, "0");

    const days = Math.floor(totalHours / 24);

    return days > 0
      ? `${totalHours.toString().padStart(2, "0")}:${m}:${s} (${days} day${
          days > 1 ? "s" : ""
        })`
      : `${totalHours.toString().padStart(2, "0")}:${m}:${s}`;
  };

  const runningTimeTemplate = (rowData: OilIntakeLogModel) => {
    return calculateElapsedTime(rowData.startTime, rowData.createdDate);
  };
  const showMessage = (
    summary: string,
    detail: string,
    severity: "success" | "error" | "warn" | "info"
  ) => {
    toast.current?.show({
      severity,
      summary,
      detail,
      life: 3000,
    });
  };
  const calculateResidue = (cake: number | null, container: number | null) => {
    if (cake != null && container != null) {
      const result = cake - container;
      setResidueWeight(result >= 0 ? parseFloat(result.toFixed(2)) : 0);
    } else {
      setResidueWeight(null);
    }
  };
  const calculateInputToOutputRatio = (
    output: number | null,
    input: number | null
  ) => {
    if (output != null && input != null && input > 0) {
      const ratio = parseFloat((output / input).toFixed(2));
      setInputToOutputRatio(ratio);
    } else {
      setInputToOutputRatio(null);
    }
  };
  const calculateDailyOutput = (total: number | null, maddi: number | null) => {
    if (total != null && maddi != null) {
      const difference = total - maddi;
      const output =
        difference > 0 ? parseFloat((difference / 0.86).toFixed(2)) : 0;
      setDailyOutputLitres(output);
      calculateInputToOutputRatio(output, oilseedWeight);
    } else {
      setDailyOutputLitres(null);
      setInputToOutputRatio(null);
    }
  };

  const fieldHoverStyle = (fieldName: string) => ({
    border:
      hoveredField === fieldName ? "2px solid #6366F1" : "1px solid #ced4da",

    boxShadow:
      hoveredField === fieldName ? "0 0 6px rgba(99, 102, 241, 0.3)" : "none",
    transition: "all 0.2s ease-in-out",
    width: "100%",
    minHeight: "40px",
  });
  const calculateMaddiWeight = (
    containerMaddi: number | null,
    empty: number | null
  ) => {
    if (containerMaddi != null && empty != null) {
      const result = containerMaddi - empty;
      setMaddiWeight(result >= 0 ? parseFloat(result.toFixed(2)) : 0);
    } else {
      setMaddiWeight(null);
    }
  };
  const resetForm = () => {
    setEndTime(new Date());
    setDailyOutputLitres(null);
    setInputToOutputRatio(null);
    setCakeWeight(null);
    setResidueContainerWeight(null);
    setResidueWeight(null);
    setSelectedRow(null);
    setTotalWeight(null);
    setContainerMaddiWeight(null);
    setContainerMaddiWeight(null);
    setContainerAndMaddiWeight(null);
    setShowDialog(false);
  };
  return (
    <>
     

            <Toast ref={toast} />
            <div className="col-15">
              <DataTable
                value={records}
                paginator
                rows={5}
                scrollable
                rowsPerPageOptions={[5, 10, 20]}
                 paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
              >
                <Column field="oilSeedName" sortable header="Oilseed Name" />
                <Column field="startTime" sortable header="Start Time" />
                <Column header="Current Time" body={runningTimeTemplate} />
                <Column field="vendorName" sortable header="Vendor Name" />
                <Column field="gaanaName" sortable header="Gaana Used" />
                <Column
                  field="operator1Name"
                  sortable
                  header="Operator 1 Name"
                />
                <Column
                  field="operator2Name"
                  sortable
                  header="Operator 2 Name"
                />
                <Column field="bull1Name" sortable header="Bull 1 Name" />
                <Column field="bull2Name" sortable header="Bull 1 Name" />
                <Column
                  header="Action"
                  body={actionTemplateStart}
                  frozen
                  style={{ width: "120px" }}
                />
                <Column
                  header="Edit"
                  body={actionTemplateEdit}
                  frozen
                  style={{ width: "120px" }}
                />
              </DataTable>
            </div>
          

      {/* Start Dialog */}
      <Dialog
        visible={showDialog}
        modal
        style={{ width: "86vw" }}
        onHide={() => setShowDialog(false)}
        footer={
          <>
            <Button
              label="Cancel"
              className="p-button-text"
              onClick={() => {
                resetForm();
                setShowDialog(false);
              }}
            />
            <Button
              label="Stop"
              className="p-button-primary"
              onClick={handleStartSave}
            />
          </>
        }
      >
        <h5 className="border-round mb-3 order-top-color p-2 panel-header-text text-center">
          Stop Oil Production
        </h5>
        <div className="p-grid">
          <div className="col-12 mb-2">
            <div className="grid">
              <div className=" col-12 md:col-4">
                <label className="label-semi-bold">
                  Oilseed Weight (kg)<span className="required">*</span>
                </label>
                <InputNumber
                  value={oilseedWeight}
                  disabled
                  onChange={(e) => {
                    const enteredWeight = e.value ?? 0;

                    if (
                      selectedInvoice?.quantityLeft &&
                      enteredWeight > selectedInvoice.quantityLeft
                    ) {
                      showMessage(
                        "Validation Error",
                        `Weight cannot exceed ${selectedInvoice.quantityLeft} kg`,
                        "error"
                      );
                      return;
                    }

                    setOilseedWeight(enteredWeight);
                    calculateInputToOutputRatio(
                      dailyOutputLitres,
                      enteredWeight
                    );
                  }}
                  placeholder="Enter weight"
                  mode="decimal"
                  minFractionDigits={2}
                  step={0.01}
                  useGrouping={false}
                  className="w-full"
                  style={fieldHoverStyle("description")}
                />
              </div>

              <div className="col-12 md:col-4">
                <label className="label-semi-bold">
                  Empty Container Weight (kg)
                </label>
                <InputNumber
                  value={emptyContainerWeight}
                  disabled
                  placeholder="Empty Container Weight"
                  mode="decimal"
                  minFractionDigits={2}
                  useGrouping={false}
                  className="w-full"
                  style={fieldHoverStyle("emptyContainerWeight")}
                />
              </div>
              {/* <div className=" col-12 md:col-4">
                <label className="label-semi-bold">
                  End Time<span className="required">*</span>
                </label>
                <Calendar
                  value={endTime}
                  onChange={(e) => setEndTime(e.value as Date)}
                  timeOnly
                  hourFormat="12"
                  stepMinute={15}
                  className="w-full"
                  style={fieldHoverStyle("description")}
                />
              </div> */}
            </div>
            <div className="grid">
              <div className="col-12 md:col-4">
                <label className="label-semi-bold">
                  Cake Weight <span className="required">*</span>
                </label>
                <InputNumber
                  value={cakeWeight}
                  onValueChange={(e) => {
                    const val = e.value ?? null;
                    setCakeWeight(val);
                    calculateResidue(val, residueContainerWeight);
                  }}
                  placeholder="Enter Cake Weight"
                  mode="decimal"
                  minFractionDigits={2}
                  step={0.01}
                  useGrouping={false}
                  className="w-full"
                  style={fieldHoverStyle("cakeWeight")}
                  onKeyPress={(e) => {
                    if (!/[0-9.]/.test(e.key)) {
                      e.preventDefault();
                    }
                    if (
                      e.key === "." &&
                      (e.currentTarget as HTMLInputElement).value.includes(".")
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (["-", "+", "e", "E"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </div>

              <div className="col-12 md:col-4">
                <label className="label-semi-bold">
                  Residue Container Weight <span className="required">*</span>
                </label>
                <InputNumber
                  value={residueContainerWeight}
                  onChange={(e) => {
                    const val = e.value ?? null;
                    setResidueContainerWeight(val);
                    calculateResidue(cakeWeight, val);
                  }}
                  placeholder="Enter Residue Container Weight"
                  mode="decimal"
                  minFractionDigits={2}
                  className="w-full"
                  style={fieldHoverStyle("residueContainerWeight")}
                  onKeyPress={(e) => {
                    if (!/[0-9.]/.test(e.key)) {
                      e.preventDefault();
                    }
                    if (
                      e.key === "." &&
                      (e.currentTarget as HTMLInputElement).value.includes(".")
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (["-", "+", "e", "E"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </div>

              <div className="col-12 md:col-4">
                <label className="label-semi-bold">
                  Residue Weight <span className="required">*</span>
                </label>
                <InputNumber
                  value={residueWeight}
                  disabled
                  placeholder="Residue Weight"
                  mode="decimal"
                  minFractionDigits={2}
                  useGrouping={false}
                  className="w-full"
                  style={fieldHoverStyle("residueWeight")}
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-4">
                <label className="label-semi-bold">
                  Total Weight (Container + Oil) (Kg){" "}
                  <span className="required">*</span>
                </label>
                <InputNumber
                  value={totalWeight}
                  onValueChange={(e) => {
                    const val = e.value ?? null;
                    setTotalWeight(val);
                    calculateDailyOutput(val, containerMaddiWeight);
                  }}
                  placeholder="Enter Total Weight (Container + Oil)"
                  mode="decimal"
                  minFractionDigits={2}
                  step={0.01}
                  useGrouping={false}
                  className="w-full"
                  style={fieldHoverStyle("totalWeight")}
                  maxLength={8}
                  onKeyPress={(e) => {
                    if (!/[0-9.]/.test(e.key)) {
                      e.preventDefault();
                    }
                    if (
                      e.key === "." &&
                      (e.currentTarget as HTMLInputElement).value.includes(".")
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (["-", "+", "e", "E"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </div>

              {/* Row 2 */}
              <div className="col-12 md:col-4">
                <label className="label-semi-bold">
                  Container and Bottom Maddi Weight (Kg){" "}
                  <span className="required">*</span>
                </label>
                <InputNumber
                  value={containerMaddiWeight}
                  onChange={(e) => {
                    const val = e.value ?? null;
                    setContainerMaddiWeight(val);
                    calculateDailyOutput(totalWeight, val);
                  }}
                  placeholder="Enter Container and Residue Weight (Kg)"
                  mode="decimal"
                  minFractionDigits={2}
                  step={0.01}
                  useGrouping={false}
                  className="w-full"
                  style={fieldHoverStyle("containerMaddiWeight")}
                  maxLength={8}
                  onKeyPress={(e) => {
                    if (!/[0-9.]/.test(e.key)) {
                      e.preventDefault();
                    }
                    if (
                      e.key === "." &&
                      (e.currentTarget as HTMLInputElement).value.includes(".")
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (["-", "+", "e", "E"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </div>

              <div className="col-12 md:col-4">
                <label className="label-semi-bold">
                  Daily Output in litres <span className="required">*</span>
                </label>
                <InputNumber
                  value={dailyOutputLitres}
                  disabled
                  placeholder="Daily Output in litres"
                  mode="decimal"
                  minFractionDigits={2}
                  step={0.01}
                  useGrouping={false}
                  className="w-full"
                  style={fieldHoverStyle("dailyOutputLitres")}
                  maxLength={8}
                />
              </div>
            </div>

            <div className="grid">
              <div className=" col-12 md:col-4">
                <label className="label-semi-bold">
                  Maddi Weight with Container
                  <span className="required">*</span>
                </label>
                <InputNumber
                  value={containerMaddiWeight}
                  onChange={(e) => {
                    const val = e.value ?? null;
                    setContainerAndMaddiWeight(val);
                    calculateMaddiWeight(val, emptyContainerWeight);
                  }}
                  placeholder="Enter Maddi Weight with Container"
                  mode="decimal"
                  minFractionDigits={2}
                  step={0.01}
                  useGrouping={false}
                  className="w-full"
                  style={fieldHoverStyle("description")}
                  maxLength={8}
                  onKeyPress={(e) => {
                    if (!/[0-9.]/.test(e.key)) {
                      e.preventDefault();
                    }
                    if (
                      e.key === "." &&
                      (e.currentTarget as HTMLInputElement).value.includes(".")
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (["-", "+", "e", "E"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </div>
              <div className=" col-12 md:col-4">
                <label className="label-semi-bold">
                  Maddi Weight
                  <span className="required">*</span>
                </label>
                <InputNumber
                  value={maddiWeight}
                  disabled
                  placeholder="Maddi Weight"
                  mode="decimal"
                  minFractionDigits={2}
                  step={0.01}
                  useGrouping={false}
                  className="w-full"
                  style={fieldHoverStyle("maddiWeight")}
                  maxLength={8}
                />
              </div>

              <div className=" col-12 md:col-4">
                <label className="label-semi-bold">
                  Input to Output Ratio
                  <span className="required">*</span>
                </label>
                <InputNumber
                  value={
                    inputToOutputRatio !== null
                      ? inputToOutputRatio * 100
                      : undefined
                  }
                  disabled
                  placeholder="Input to Output Ratio"
                  mode="decimal"
                  minFractionDigits={2}
                  step={0.01}
                  useGrouping={false}
                  className="w-full"
                  style={fieldHoverStyle("inputToOutputRatio")}
                  maxLength={8}
                  suffix="%"
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      {/* Edit Dialog */}
      <Dialog
        // header="Edit Oil Intake Details"
        visible={showEditDialog}
        modal
        style={{ width: "60vw" }}
        onHide={() => setShowDialog(false)}
        footer={
          <>
            <Button
              label="Cancel"
              className="p-button-text"
              onClick={() => setShowEditDialog(false)}
            />
            <Button
              label="Save"
              className="p-button-primary"
              onClick={handleEditSave}
            />
          </>
        }
      >
        <h5 className="border-round mb-3 order-top-color p-2 panel-header-text text-center">
          Edit Oil Operator Details
        </h5>
        <div className="p-grid">
          <div className="col-12 mb-2">
            <div className="grid">
              <div className="field col-12 md:col-6">
                <label>Gaana Number <span className="required">*</span></label>
                <Dropdown
                disabled
                  value={gaanaNumber}
                  options={gaanaOptions}
                  onChange={(e) => setGaanaNumber(e.value)}
                  optionLabel="label"
                  optionValue="value"
                  style={fieldHoverStyle("description")}
                  placeholder="Select Gaana Number"
                  
                />
              </div>
              <div className="field col-12 md:col-6">
                <label>Oilseed <span className="required">*</span></label>
                <Dropdown
                disabled
                  value={oilseed?.value ?? null}
                  options={oilseedOptions}
                  onChange={async (e) => {
                    const selectedOilseed = e.value;
                    setOilseed(selectedOilseed);

                    if (!selectedOilseed) {
                      setVendors([]);
                      setVendorInvoices([]);
                      setSelectedVendor(null);
                      setInvoiceOptions([]);
                      setSelectedInvoice(null);
                      return;
                    }

                    try {
                      const response: VendorResponse[] =
                        await oilProductionService.getVendorsByOilseed(
                          selectedOilseed.value
                        );
                      const formattedVendors: DropdownOption[] = response.map(
                        (vendor) => ({
                          label: vendor.firmInfo,
                          value: vendor.vendorID,
                        })
                      );
                      setVendors(formattedVendors);
                      setVendorInvoices(response);
                      setSelectedVendor(null);
                      setInvoiceOptions([]);
                      setSelectedInvoice(null);
                    } catch (err) {
                      console.error("Error fetching vendors:", err);
                    }
                  }}
                  placeholder="Select Oilseed Name"
                  optionLabel="label"
                  className="w-full"
                  style={fieldHoverStyle("description")}
                />{" "}
              </div>
              <div className="field col-12 md:col-6">
                <label>Vendor <span className="required">*</span></label>
                <Dropdown
                disabled
                  value={selectedVendor}
                  options={vendorOptions}
                  onChange={(e) => {
                    const selectedVendorId = e.value;
                    setSelectedVendor(selectedVendorId);

                    const vendor = vendorInvoices.find(
                      (v) => v.vendorID === selectedVendorId
                    );
                    if (vendor && vendor.invoices) {
                      const formattedInvoices: InvoiceOption[] =
                        vendor.invoices.map((inv) => ({
                          label: `${inv.invoiceID} - ${inv.quantityLeft} kg`,
                          value: inv.rawMaterialPurchaseID,
                          quantityLeft: inv.quantityLeft,
                        }));

                      setInvoiceOptions(formattedInvoices);
                      setSelectedInvoice(null);
                    }
                  }}
                  placeholder="Select Vendor Name"
                  className="w-full"
                  style={fieldHoverStyle("description")}
                />
              </div>
              <div className="field col-12 md:col-6">
                <label>Invoice <span className="required">*</span></label>
                <Dropdown
                disabled
                  value={selectedInvoice?.value || null}
                  options={invoiceOptions}
                  onChange={(e) => {
                    const selected = invoiceOptions.find(
                      (inv) => inv.value === e.value
                    );
                    setSelectedInvoice(selected || null);
                  }}
                  optionLabel="label"
                  placeholder="Select Vendor Invoice Number"
                  style={fieldHoverStyle("description")}
                  className="w-full"
                />
              </div>

              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Oilseed Weight (kg)<span className="required">*</span>
                </label>
                <InputNumber
                disabled
                  value={oilseedWeight}
                  onChange={(e) => {
                    const enteredWeight = e.value ?? 0;

                    if (
                      selectedInvoice?.quantityLeft &&
                      enteredWeight > selectedInvoice.quantityLeft
                    ) {
                      showMessage(
                        "Validation Error",
                        `Weight cannot exceed ${selectedInvoice.quantityLeft} kg`,
                        "error"
                      );
                      return;
                    }

                    setOilseedWeight(enteredWeight);
                    calculateInputToOutputRatio(
                      dailyOutputLitres,
                      enteredWeight
                    );
                  }}
                  placeholder="Enter weight"
                  mode="decimal"
                  minFractionDigits={2}
                  step={0.01}
                  useGrouping={false}
                  className="w-full"
                  style={fieldHoverStyle("description")}
                />
              </div>
              <div className="field col-12 md:col-6">
                <label>Moisture Content (%)<span className="required">*</span></label>
                <InputNumber
                disabled
                  value={moistureContent}
                  onValueChange={(e) => setMoistureContent(e.value ?? null)}
                  mode="decimal"
                  step={0.01}
                  minFractionDigits={2}
                  style={fieldHoverStyle("description")}
                />
              </div>
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Empty Container Weight (kg)<span className="required">*</span>
                </label>
                <InputNumber
                disabled
                  value={emptyContainerWeight}
                  onValueChange={(e) =>
                    setEmptyContainerWeight(e.value ?? null)
                  }
                  mode="decimal"
                  step={0.01}
                  minFractionDigits={2}
                  style={fieldHoverStyle("description")}
                />
              </div>
              
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Operator 1<span className="required">*</span>
                </label>
                <Dropdown
                  value={selectedOperator1}
                  options={operators.filter(
                    (op) =>
                      selectedOperator2 == null ||
                      op.value !== selectedOperator2
                  )}
                  onChange={(e) => setSelectedOperator1(e.value)}
                  placeholder="Select Operator 1"
                  style={fieldHoverStyle("description")}
                  optionLabel="label"
                />
              </div>

              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Operator 2
                </label>
                <Dropdown
                  value={selectedOperator2}
                  options={operators.filter(
                    (op) =>
                      selectedOperator1 == null ||
                      op.value !== selectedOperator1
                  )}
                  onChange={(e) => setSelectedOperator2(e.value)}
                  placeholder="Select Operator 2"
                  style={fieldHoverStyle("description")}
                  optionLabel="label"
                />
              </div>

              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Bull 1<span className="required">*</span>
                </label>
                <Dropdown
                  value={selectedBull1}
                  options={bulls.filter(
                    (b) => selectedBull2 == null || b.value !== selectedBull2
                  )}
                  onChange={(e) => setSelectedBull1(e.value)}
                  placeholder="Select Bull 1"
                  style={fieldHoverStyle("description")}
                  optionLabel="label"
                />
              </div>

              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Bull 2
                </label>
                <Dropdown
                  value={selectedBull2}
                  options={bulls.filter(
                    (b) => selectedBull1 == null || b.value !== selectedBull1
                  )}
                  onChange={(e) => setSelectedBull2(e.value)}
                  placeholder="Select Bull 2"
                  style={fieldHoverStyle("description")}
                  optionLabel="label"
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      <Dialog
  visible={showConfirmEndTimeDialog}
  modal
  header="Confirm End Time"
  onHide={() => setShowConfirmEndTimeDialog(false)}
  style={{ width: "30vw" }}
  footer={
    <>
      <Button
        label="Cancel"
        className="p-button-text"
        onClick={() => setShowConfirmEndTimeDialog(false)}
      />
      <Button
        label="Yes, Save"
        className="p-button-primary"
        onClick={async () => {
          setShowConfirmEndTimeDialog(false);
          await confirmSaveWithEndTime();
        }}
      />
    </>
  }
>
    <div >
                <label className="label-semi-bold">
                  End Time<span className="required">*</span>
                </label>
               <Calendar
  value={endTime}
  onChange={(e) => setEndTime(e.value as Date)}
  timeOnly
  hourFormat="12"
  stepMinute={15}
  readOnlyInput 
  showIcon 
  className="w-full"
  style={fieldHoverStyle("description")}
/>

              </div>
  {/* <p>
    The end time will be set to:{" "}
    <strong>{proposedEndTime.toLocaleTimeString()}</strong>
  </p> */}
  {/* <p>Do you want to proceed and save?</p> */}
</Dialog>

    </>
  );
};

export default OilProductionDataTable2;
